// extracted by mini-css-extract-plugin
export default {"modal-backdrop":"Modal_modal-backdrop__obK04","modal-content":"Modal_modal-content__V9BFZ","md":"Modal_md__yXb0o","lg":"Modal_lg__d7IKV","close-button":"Modal_close-button__RECyQ"};